import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ShowcaseRoutingModule } from './showcase-routing.module';
import { ShowcaseComponent } from './component/showcase/showcase.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { HttpClientModule } from '@angular/common/http';
import { MovieInfoComponent } from './component/movie-info/movie-info.component';
import { StreamComponent } from './component/stream/stream.component';
import { RateMovieComponent } from './component/dialog/new-post/rate-movie/rate-movie.component';
import { MovieComponent } from './component/movie-list/movie.component';
import { ShareButtonComponent } from './component/share-button/share-button.component';
import { MoviePageSideBarComponent } from './component/movie-info/movie-page-side-bar/movie-page-side-bar.component';
import { CustomFxModule } from 'src/app/core/custom-fx/custom-fx.module';
import { ShowcaseArchiveComponent } from './component/showcase-archive/showcase-archive.component';
import { NewMovieInfoComponent } from './component/new-movie-info/new-movie-info.component';
import { ShowcaseUiWrapperComponent } from './component/showcase-ui-wrapper/showcase-ui.component';
import { CommunityChatComponent } from './component/community-chat/community-chat.component';
import { SafeUrlPipe } from 'src/app/core/Pipe/safe-url.pipe';
import { ExtraSpaceAfterCommaPipe } from 'src/app/core/Pipe/extra-space-comma.pipe';
import { CommunityChatMobileComponent } from './component/community-chat-mobile/community-chat-mobile.component';

@NgModule({
  declarations: [
    ShowcaseComponent,
    MovieInfoComponent,
    StreamComponent,
    RateMovieComponent,
    MovieComponent,
    ShareButtonComponent,
    MoviePageSideBarComponent,
    ShowcaseArchiveComponent,
    NewMovieInfoComponent,
    ShowcaseUiWrapperComponent,
    CommunityChatComponent,
    SafeUrlPipe,
    ExtraSpaceAfterCommaPipe,
    CommunityChatMobileComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    ShowcaseRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatTabsModule,
    FlexLayoutModule,
    CustomFxModule
  ],
  exports: [
    MoviePageSideBarComponent
  ]
})
export class ShowcaseModule {}
